import { NextSeo } from 'next-seo';
import PageHeader from '../components/PageHeader';
import TheLotteryPage from '../components/TheLotteryPage';

export default function Lottery() {
  const title = 'Shitty Vault Lottery - Shitty Kitties';
  const description = `Win $ALGO each week with the Shitty Vault Lottery.`;

  return (
    <div>
      <NextSeo title={title} description={description} />
      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader heading={'Shitty Vault Lottery'} description={description} fullWidth />

        <div className='px-4 lg:mx-auto lg:px-8'>
          <div className='max-w-2xl mx-auto text-center py-12'>
            <h2 className='text-2xl font-bold text-white mb-4'>Lottery Temporarily Paused</h2>
            <p className='text-gray-300 text-lg'>We've temporarily paused the Shitty Vault Lottery. Check back soon for updates!</p>
          </div>
        </div>
      </div>
    </div>
  );
}
